import axios from 'axios'

// This is the transfer module
const state = {
    amount_send: null,
    currency_send: null,
    name: null,
    phone_number: null,
    card_number: null,
    account_number: null
}

const getters = {
    // StateFee: (state) => !!state.fee
}

const actions = {
    async ActionTransfer({ commit }, transfer) {
        await commit("setTransfer", transfer)
        return true
    }
}

const mutations = {
    setTransfer(state, transfer) {
        state.amount_send = transfer.amount_send
        state.currency_send = transfer.currency_send
        state.name = transfer.name
        state.phone_number = transfer.phone_number
        state.card_number = transfer.card_number
        state.account_number = transfer.account_number
    },
    resetTransfer(state) {
        state.amount_send = null
        state.currency_send = null
        state.name = null
        state.phone_number = null
        state.card_number = null
        state.account_number = null
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}